var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuseum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "museum",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M396.426,268.344h4.687v11.223h-4.687Zm0,0",
    transform: "translate(-365.454 -247.38)",
    fill: "#3c4b61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M282.809,268.344H287.5v11.223h-4.687Zm0,0",
    transform: "translate(-260.713 -247.38)",
    fill: "#3c4b61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M169.191,268.344h4.688v11.223h-4.688Zm0,0",
    transform: "translate(-155.972 -247.38)",
    fill: "#3c4b61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M55.578,268.344h4.687v11.223H55.578Zm0,0",
    transform: "translate(-51.235 -247.38)",
    fill: "#3c4b61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M70.019,209.516v-1.172H35.578v1.172a1.172,1.172,0,0,0,1.172,1.172h32.1A1.172,1.172,0,0,0,70.019,209.516Zm0,0",
    transform: "translate(-32.797 -192.067)",
    fill: "#3c4b61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M38.841,442H1.187a1.172,1.172,0,0,0-1.172,1.172V446.3a1.172,1.172,0,0,0,1.172,1.172H38.841a1.172,1.172,0,0,0,1.172-1.172v-3.125A1.172,1.172,0,0,0,38.841,442Zm0,0",
    transform: "translate(-0.013 -407.469)",
    fill: "#3c4b61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M1.173,13.933H38.829a1.172,1.172,0,0,0,.614-2.17L20.616.174a1.172,1.172,0,0,0-1.229,0L.559,11.763a1.172,1.172,0,0,0,.614,2.17ZM19.2,6.893H20.8a1.172,1.172,0,1,1,0,2.344H19.2a1.172,1.172,0,0,1,0-2.344Zm0,0",
    transform: "translate(0 0)",
    fill: "#3c4b61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseum);
export default __webpack_public_path__ + "static/media/museum.d2ab0171e191efc997417a404c1c4236.svg";
export { ForwardRef as ReactComponent };